export enum ActionTypes {
  INITIALISE = 'INITIALISE',
  SET_LOADING = 'SET_LOADING',
  SET_ERROR = 'SET_ERROR',
  SET_FACETS = 'SET_FACETS',
  SET_QUERY_TEXT = 'SET_QUERY_TEXT',
  SET_FILTER_CHANGED = 'SET_FILTER_CHANGED',
  SET_INDEX_NAME = 'SET_INDEX_NAME',
}
